var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddPhotoAlternate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9716_20408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0013 16.6693H3.33464V5.0026H10.8346V3.33594H3.33464C2.41797 3.33594 1.66797 4.08594 1.66797 5.0026V16.6693C1.66797 17.5859 2.41797 18.3359 3.33464 18.3359H15.0013C15.918 18.3359 16.668 17.5859 16.668 16.6693V9.16927H15.0013V16.6693ZM8.50964 14.0276L6.8763 12.0609L4.58464 15.0026H13.7513L10.8013 11.0776L8.50964 14.0276ZM16.668 3.33594V0.835938H15.0013V3.33594H12.5013C12.5096 3.34427 12.5013 5.0026 12.5013 5.0026H15.0013V7.49427C15.0096 7.5026 16.668 7.49427 16.668 7.49427V5.0026H19.168V3.33594H16.668Z",
    fill: "#98A2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9716_20408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhotoAlternate);
export default __webpack_public_path__ + "static/media/add_photo_alternate.2e354d389e2dbeaf9a6794c6b0da5cb4.svg";
export { ForwardRef as ReactComponent };